import axiosInstance from './axiosInstance';

const getUserStats = async ({ token }) => {
  try {
    const response = await axiosInstance.post(
      '/userstats',
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error fetching user stats: ' + error.message);
  }
};

export { getUserStats };
